import { render } from "./ModelosPropostaForm.vue?vue&type=template&id=8f547020"
import script from "./ModelosPropostaForm.vue?vue&type=script&lang=js"
export * from "./ModelosPropostaForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__